var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJourneyCardOneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1063_3529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6606 30.7091C32.6606 31.9655 33.6562 32.9938 34.9 33.0463V34.9H4.29105C1.98016 34.9 0.1 33.0199 0.1 30.709C0.1 28.3982 1.98016 26.5181 4.29105 26.5181H5.04506C6.33513 26.5181 7.38444 25.4687 7.38444 24.1787C7.38444 22.9223 6.38892 21.8941 5.14506 21.8415V19.9878H26.6744C28.9853 19.9878 30.8654 21.868 30.8654 24.1788C30.8654 24.9798 30.6393 25.7286 30.2478 26.3658L30.1542 26.5181H30.333H34.9V28.3718C33.6562 28.4244 32.6606 29.4527 32.6606 30.7091ZM8.7042 21.8394H8.52542L8.61899 21.9918C9.01028 22.6288 9.23611 23.3778 9.23611 24.1787C9.23611 24.9796 9.01021 25.7287 8.61899 26.3657L8.52544 26.5181H8.7042H26.6743C27.9644 26.5181 29.0137 25.4687 29.0137 24.1787C29.0137 22.8888 27.9644 21.8394 26.6743 21.8394H8.7042ZM31.3409 33.0484H31.5196L31.4261 32.8961C31.0348 32.259 30.8089 31.51 30.8089 30.7091C30.8089 29.9082 31.0348 29.1592 31.426 28.5221L31.5196 28.3698H31.3408H26.6743H4.29105C3.00098 28.3698 1.95167 29.4192 1.95167 30.7091C1.95167 31.999 3.00098 33.0484 4.29105 33.0484H31.3409Z",
    fill: "#F6821F",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0938 7.31526L26.0338 7.34142V7.40694V15.8953C23.2496 16.7303 20.4128 17.2381 17.4999 17.2381C14.5868 17.2383 11.7503 16.7303 8.96599 15.8953V7.40694V7.34142L8.90591 7.31526L4.92869 5.58332L17.4998 0.10907L30.0711 5.58332L26.0938 7.31526ZM24.1086 14.5208L24.1829 14.501V14.4242V8.29992V8.14731L24.043 8.20824L17.4998 11.0575L10.9566 8.20824L10.8167 8.14731V8.29992V14.4242V14.501L10.891 14.5208C15.2284 15.6748 19.7714 15.6748 24.1086 14.5208ZM17.5398 2.14585L17.4998 2.12847L17.4599 2.14585L9.77667 5.49164L9.56612 5.58332L9.77667 5.675L17.4599 9.02072L17.4998 9.0381L17.5398 9.02072L25.223 5.675L25.4336 5.58332L25.223 5.49164L17.5398 2.14585Z",
    fill: "#F6821F",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1063_3529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourneyCardOneIcon);
export default __webpack_public_path__ + "static/media/journeyCardOneIcon.e809818a78e7b8589ba36a14b7352f76.svg";
export { ForwardRef as ReactComponent };